import { Component, OnInit } from "@angular/core";
import { LangChangeEvent, TranslateService } from "@ngx-translate/core";
import { ActivatedRoute } from '@angular/router';
import { Subscription } from "rxjs";
import { ApiService } from "../../shared/services/api.service";

@Component({
    selector: 'app-trazabilidad-certificado',
    templateUrl: './trazabilidad-certificado.component.html',
    styleUrls: ['./trazabilidad-certificado.component.scss']
})

export class TrazabilidadCertificadoComponent implements OnInit {
    public certificateTraceability: any;
    public title = '';
    public showSpinner = false;
    public showNoTraceabilityText = false;
    private titleTimeouts: ReturnType<typeof setTimeout>[] = [];
    private langChangeSubscription!: Subscription;
    private paramsSubscription!: Subscription;

    // Componente stepper
    public steps = [
        'trazabilidad-certificado.informe.procesoCultivo',
        'trazabilidad-certificado.informe.procesoDesignacion',
        'trazabilidad-certificado.informe.procesoConfeccion',
        'trazabilidad-certificado.informe.procesoExpedicion'
    ];
    public icons = [
        'fas fa-seedling i-cultivo',
        'fas fa-handshake i-designacion',
        'fas fa-boxes-stacked i-confeccion',
        'fas fa-truck i-expedicion'
    ];
    // Desplegables anidados del stepper (se prepara para posibles nuevos desplegables en un futuro)
    public parentPosition = 0;
    public blockchainInfoHeight = 0;
    public blockchainAction = '';

    constructor(
        private translate: TranslateService,
        private activatedRoute: ActivatedRoute,
        private apiService: ApiService
    ) {}

    ngOnInit(): void {
        this.translate.get('trazabilidad-certificado.informe.titulo').subscribe((text: string) => {
            this.title = text;
            this.typeTitle(this.title, 'certificate-traceability-title');
        });

        // Para refrescar el título al cambiar de idioma
        this.langChangeSubscription = this.translate.onLangChange.subscribe((_event: LangChangeEvent) => {
            this.translate.get('trazabilidad-certificado.informe.titulo').subscribe((text: string) => {
                this.title = text;
                this.resetTitle('certificate-traceability-title');
                this.typeTitle(this.title, 'certificate-traceability-title');
            });
        });

        this.paramsSubscription = this.activatedRoute.queryParams.subscribe(
            params => {
                if (params['certNumber']) {
                    this.getCertificateTraceability(params['certNumber']);
                }
            }
        );
    }

    ngOnDestroy(): void {
        this.langChangeSubscription?.unsubscribe();
        this.paramsSubscription?.unsubscribe();

        this.clearTitleTimeouts();
    }

    public get defaultLanguage() {
        return this.translate.currentLang;
    }

    private typeTitle(text: string, id: string) {
        if (text.length > 0) {
            const element = document.getElementById(id);

            if (element) {
                element.innerHTML += text.charAt(0);
                this.titleTimeouts.push(setTimeout(() => this.typeTitle(text.slice(1), id), 20));
            }
            
        }
    }

    private clearTitleTimeouts() {
        for (let i = 0; i < this.titleTimeouts.length; i++) {
            clearTimeout(this.titleTimeouts[i]);
        }
        this.titleTimeouts = [];
    }

    private resetTitle(id: string) {
        this.clearTitleTimeouts();

        const titleElement = document.getElementById(id);
        if (titleElement) {
            titleElement.innerHTML = '';
        }
    }

    private getCertificateTraceability(certificateNum: string) {
        this.certificateTraceability = null;
        const filters = {
            idiomaID: this.apiService.getLanguageId(),
            num: certificateNum
        };

        this.showNoTraceabilityText = false;
        this.showSpinner = true;
        this.apiService.getCertificateTraceability(filters).subscribe(
            resp => {
                this.certificateTraceability = resp;
            },
            error => {
                this.showNoTraceabilityText = true;
            }
        ).add(() => {
            this.showSpinner = false;
        });
    }

    /**
     * Expandir o contraer los datos del blockchain
     * 
     * @param parentIndex La posisión del .step-content que se envía al componente stepper
     * @param accordionSection El apartado en que se encuentra el acordeón: Cultivo, Designación o Confección
     */
    public showOrHideData(parentIndex: number, accordionSection: string) {
        const blockchainContainer = document.getElementsByClassName(`blockchain-container-${accordionSection}`)[0] as HTMLElement;
        const blockchainArrow = document.getElementsByClassName(`blockchain-arrow-${accordionSection}`)[0] as HTMLElement;
        const blockchainData = document.getElementsByClassName(`blockchain-content-${accordionSection}`)[0] as HTMLElement;
        let dataHeight: number;

        // Desplegamos los datos del blockchain
        if (blockchainContainer.classList.contains('collapsed')) {
            blockchainContainer.classList.remove('collapsed');
            blockchainArrow.style.transform = 'rotate(-180deg)';
            dataHeight = blockchainData.scrollHeight;
            blockchainData.style.height = dataHeight + "px";
            this.blockchainInfoHeight = dataHeight;
            this.parentPosition = parentIndex;
            this.blockchainAction = `open${accordionSection}`;
        // Contraemos los datos
        } else if (!blockchainContainer.classList.contains('collapsed')) {
            blockchainContainer.classList.add('collapsed');
            blockchainArrow.style.transform = 'rotate(0)';
            blockchainData.style.height = "0";
            this.parentPosition = parentIndex;
            this.blockchainAction = `close${accordionSection}`;
        }
    }
  
    public getBlockchainLink(txId: string): string {
        const baseUrl = 'https://explore.vechain.org/';
        return txId ? `${baseUrl}transactions/${txId}` : baseUrl;
    }
}
